export const imgDonaMalvina = {
    src: 'images/dona_malvina.jpg',
    alt: 'Dona Malvina',
    text: 'Dona Malvina'
};

export const imgSeuLele = {
    src: 'images/seu_lele.jpg',
    alt: 'Sr. Lele',
    text: 'Sr. Lelê'
};

export const imgDonaZeze = {
    src: 'images/dona_zeze.jpg',
    alt: 'Dona Zezé',
    text: 'Dona Zezé'
};

export const imgRafaelFadel = {
    src: 'images/rafael_fadel.png',
    alt: 'Rafael Fadel',
    text: 'Rafael Fadel'
};

// Array of all testimonial data for easier mapping
export const testimonialData = [
    {
        id: 1,
        title: 'Dona Malvina',
        image: imgDonaMalvina,
        linkTo: '/testemunhos/dona-malvina',
        text: 'Por vezes ela (Brígida) ainda bem pequena pegava seu almoço ou jantar e ia escondida dividir com os filhos dos colonos da fazenda pois sabia que não faltava alimento para eles mas como na sua casa sempre tinha variedades podia partilhar com eles. Sempre foi de muita oração, tanto que na adolescência foi catequista e ajudou na formação de muitos dos colonos da fazenda onde morava quanto da região. Era uma pessoa que desde criança só se ocupava em fazer o bem.',
        fullContent: [
            {
                type: 'intro',
                content: 'A Senhora Malvina Zanconato, conhecida como Dona Malvina, nasceu no ano de 1926 e faleceu em 2020. Conviveu com os pais de Brigida. Dona Malvina concedeu uma entrevista a Denis Pitassi pouco tempo antes de seu falecimento. Leia a entrevista a seguir.'
            },
            {
                type: 'question',
                content: 'Como a senhora conheceu a Brígida?'
            },
            {
                type: 'answer',
                content: 'Não tive a oportunidade de conviver com ela mas sim com seus pais. Sr. Chiquinho tinha verdadeira paixão pela filha, sofreram muito quando ela morreu mas sabiam que ela estava do lado de Deus.'
            },
            {
                type: 'question',
                content: 'A senhora sabe alguma história referente à infância dela?'
            },
            {
                type: 'answer',
                content: 'Sim, os pais contavam com orgulho suas atitudes. Por vezes ela ainda bem pequena pegava seu almoço ou jantar e ia escondida dividir com os filhos dos colonos da fazenda pois sabia que não faltava alimento para eles mas como na sua casa sempre tinha variedades podia partilhar com eles. Sempre foi de muita oração, tanto que na adolescência foi catequista e ajudou na formação de muitos dos colonos da fazenda onde morava quanto da região. Era uma pessoa que desde criança só se ocupava em fazer o bem.'
            },
            {
                type: 'question',
                content: 'Conhece bem sobre a gruta de Nossa Senhora de Lourdes?'
            },
            {
                type: 'answer',
                content: 'Sim, foi construída por seus pais, foi um pedido dela antes de morrer pois era devota de Nossa Senhora de Lourdes. Eles contavam que ainda criança ela dizia que tinha uma visão de uma gruta com uma "janela" onde estava a Virgem Santíssima e que um dia queria que fizessem uma casinha igual a essa pra que as pessoas pudessem passar e ver a Mãezinha na "janela". E assim quando adulta antes de sua morte renovou esse pedido.'
            },
            {
                type: 'question',
                content: 'É verdade que as pessoas vinham rezar na gruta?'
            },
            {
                type: 'answer',
                content: 'Eram muitas pessoas, assim que ela morreu e a gruta foi construída as pessoas da região, aqueles que ela evangelizou ou conheciam sua história, faziam verdadeiras peregrinações para cá. Vinham participar da Santa Missa, rezar o terço, pegar água para beber e passar nas enfermidades. Era ela muito conhecida na região.'
            },
            {
                type: 'question',
                content: 'Sabe se tem algum testemunho daqueles que vinham nessas peregrinações?'
            },
            {
                type: 'answer',
                content: 'Testemunho ouvi muitos (sic), não era como hoje que se grava tudo, pude guardar tudo no coração. Tiveram (sic) muitas curas de enfermidades mas acho que o maior testemunho é o amor a Deus que despertava no coração das pessoas.'
            },
            {
                type: 'question',
                content: 'Que lindo, quero agradecer a senhora por todo carinho e atenção.'
            },
            {
                type: 'answer',
                content: 'Eu que agradeço meu filho, obrigada pela oportunidade de falar da Bidinha. Gostava muito dos pais dela e sempre admirei sua história. Ela intercede por nós no céu.'
            }
        ]
    },
    {
        id: 2,
        title: 'Sr. Lelê',
        image: imgSeuLele,
        linkTo: '/testemunhos/sr-lele',
        text: 'Foi através de uma amiga da cidade de Estrela Dalva-MG que me presenteou um dia com a sua biografia. Fiquei encantado em saber que a Bidinha que ouvia falar tinha uma história assim.',
        fullContent: [
            {
                type: 'intro',
                content: 'Confira a seguir a entrevista concedida pelo saudoso senhor Wilson Madeira — conhecido como Sr. Lelê — a Denis Pitassi no ano de 2018.'
            },
            {
                type: 'question',
                content: 'Como o senhor conheceu a história da Brígida?'
            },
            {
                type: 'answer',
                content: 'Foi através de uma amiga da cidade de Estrela Dalva-MG que me presenteou um dia com a sua biografia. Fiquei encantado em saber que a Bidinha que ouvia falar tinha uma história assim.'
            },
            {
                type: 'question',
                content: 'Como o senhor passou a cuidar com tanto zelo da gruta?'
            },
            {
                type: 'answer',
                content: 'Sempre que chegava na Igreja percebia que ali tinha um certo abandono. Por mais que os Padres cuidassem da Igreja, e faziam isso muito bem, lá estava sempre sujo e até por vezes vandalizado. Então pedi ao Padre da época para cuidar. Numa obra que foi realizada na Igreja foram tiradas as grades , que não faziam parte do conjunto arquitetônico,e as colocamos no entorno da gruta dando assim maior proteção e com a ajuda de outras pessoas vamos mantendo limpo e cuidado.'
            },
            {
                type: 'question',
                content: 'Na época o senhor já conhecia a biografia?'
            },
            {
                type: 'answer',
                content: 'As duas coisas se misturam, foi quase a mesma época, acredito que foi providência de Deus. Já tinha começado a planejar no coração cuidar da gruta, já que sou devoto de Nossa Senhora,e logo veio a minha amiga me presentear com a Biografia.'
            },
            {
                type: 'question',
                content: 'Conhece alguma história da infância da Brígida ou testemunho de alguma graça que alguém alcançou rezando aqui?'
            },
            {
                type: 'answer',
                content: 'Não tenho muita informação de sua vida, só o que conheci no livro e alguns relatos de conhecidos. Mas sei que desde o dia que li essa Biografia rezo pedindo sua intercessão e sinto que ela roga a Deus por mim.'
            },
            {
                type: 'question',
                content: 'Obrigado meu amigo por sua atenção e disponibilidade'
            },
            {
                type: 'answer',
                content: 'Eu quem agradeço por contribuir um pouquinho com o que sei. Bidinha intercede por nós'
            }
        ]
    },
    {
        id: 3,
        title: 'Dona Zezé',
        image: imgDonaZeze,
        linkTo: '/testemunhos/dona-zeze',
        text: 'Bidinha foi uma moça considerada santa (...). Após sua morte, seu pai — rico fazendeiro — construiu a Gruta de Lourdes, como promessa.',
        fullContent: [
            {
                type: 'intro',
                content: 'A senhora Maria José Elmais, nascida em 1923 e mais conhecida como Dona Zezé, concedeu uma breve entrevista a sua filha Lúcia Bezerra, no ano de 2025. Confira abaixo a conversa entre mãe e filha, que foi reconstituída em formato de narrativa, de forma a preservar o conteúdo essencial.'
            },
            {
                type: 'answer',
                content: 'Em Setembro de 2025, durante uma conversa familiar, Lúcia Bezerra registrou lembranças contadas por sua mãe, Dona Zezé, sobre uma jovem conhecida pelo apelido de Bidinha, considerada à época uma “moça santa”.'
            },
            {
                type: 'answer',
                content: 'Segundo Dona Zezé, o pai da jovem — Chiquinho Figueira — era um fazendeiro rico. Ele teria custeado obras religiosas, como uma reforma significativa na igreja e a construção de uma gruta, como promessa, após a morte de Bidinha.'
            },
            {
                type: 'answer',
                content: 'Sobre a devoção local, Dona Zezé contou que eram principalmente moradores da região e parentes que faziam peregrinação à gruta. Quando havia intenção de rezar missas, podia-se escolher entre realizá-las na gruta ou dentro da igreja.'
            },
            {
                type: 'answer',
                content: 'Um detalhe curioso mencionado foi que a avó de Lúcia desejava batizar uma filha com o nome de Brígida, porém o avô não permitiu.'
            },
            {
                type: 'answer',
                content: 'Assim, entre memórias fragmentadas, a história de Bidinha se mantém viva na tradição oral de Angustura.'
            }
        ]
    },
        {
        id: 4,
        title: 'Rafael Fadel',
        image: imgRafaelFadel, // TODO change image
        linkTo: '/testemunhos/rafael-fadel',
        text: 'O pequeno Rafael Fadel, diagnosticado com ?, teve uma melhora significativa após uma amiga da família rezar na gruta de Nossa Senhora de Lourdes em Angustura.',
        fullContent: [
            {
                type: 'intro',
                content: 'O pequeno Rafael Fadel foi diagnosticado com ? aos ? anos de idade. Seus pais, preocupados com a saúde do filho, buscaram diversas formas de tratamento médico. No entanto, foi após uma amiga da família rezar na gruta de Nossa Senhora de Lourdes em Angustura que Rafael apresentou uma melhora significativa em sua condição. Confira a seguir a entrevista concedida por sua avó Augusta Mara Fadel, em Novembro de 2025.'
            },
            {
                type: 'question',
                content: 'Conte um pouco sobre o Rafael.'
            },
            {
                type: 'answer',
                content: '(...)'
            },
            {
                type: 'question',
                content: 'Qual foi o diagnóstico inicial do Rafael? Quais sintomas ele apresentava?'
            },
            {
                type: 'answer',
                content: '(...)'
            },
            {
                type: 'question',
                content: 'Qual foi o prognóstico dos médicos?'
            },
            {
                type: 'answer',
                content: '(...)'
            },
            {
                type: 'question',
                content: 'Quando o Rafael começou a apresentar melhoras?'
            },
            {
                type: 'answer',
                content: '(...)'
            },
            {
                type: 'question',
                content: 'Vocês atribuem a melhora dele à intercessão da Brígida?'
            },
            {
                type: 'answer',
                content: '(...)'
            },
            {
                type: 'question',
                content: 'Como está o Rafael hoje?'
            },
            {
                type: 'answer',
                content: '(...)'
            },
            {
                type: 'question',
                content: 'Qual a relação de vocês com Angustura? Já conheciam a Gruta de Lourdes e a história da Brígida?'
            },
            {
                type: 'answer',
                content: '(...)'
            }
        ]
    }
];
